// Banner do topo da Visão Geral (dono, 26/10/2026): o Núcleo fala com todas as
// lojas — aviso de fim de ano, Black Friday, campanha de indicação. Sem banner
// (ou se a imagem não carregar), o espaço não aparece.
import React, { useEffect, useState } from "react";

import { lerBanner } from "./api";

export default function BannerPainel() {
  const [banner, setBanner] = useState(null);
  const [quebrou, setQuebrou] = useState(false);

  useEffect(() => {
    let vivo = true;
    lerBanner().then((b) => vivo && setBanner(b)).catch(() => {});
    return () => { vivo = false; };
  }, []);

  if (!banner || quebrou) return null;

  const imagem = (
    <picture>
      {banner.imagem_celular_url && <source media="(max-width: 640px)" srcSet={banner.imagem_celular_url} />}
      <img src={banner.imagem_url} alt={banner.texto || "Aviso do Núcleo"} onError={() => setQuebrou(true)}
        className="block w-full h-auto" />
    </picture>
  );
  const classe = "block mb-4 overflow-hidden rounded-2xl border border-border/60 shadow-sm";

  return banner.link ? (
    <a href={banner.link} target="_blank" rel="noopener noreferrer" className={`${classe} transition-opacity hover:opacity-95`}
      data-e2e="banner-painel">
      {imagem}
    </a>
  ) : (
    <div className={classe} data-e2e="banner-painel">{imagem}</div>
  );
}
